module.exports = __webpack_public_path__ + "static/images/icons/default/icon-search-input-phone-e7cbb71c1c2f82ad4411bc1351fec6bd.svg";